import { apiService } from "../../../utils/api/api.service";
import { requestWithErrorHandling } from "../../../utils/error/handle.error";

class NotificationsService {
  private static instance: NotificationsService;

  static getInstance(): NotificationsService {
    if (!NotificationsService.instance) {
      NotificationsService.instance = new NotificationsService();
    }
    return NotificationsService.instance;
  }

  getNotifications = () => {
    return requestWithErrorHandling(async () => {
      return await apiService.get<any>("/notifications");
    });
  };

  getUnreadCount = () => {
    return requestWithErrorHandling(async () => {
      return await apiService.get<any>("/notifications/unread-count");
    });
  };

  markAsRead = (id: string) => {
    return requestWithErrorHandling(async () => {
      return await apiService.put<any>(`/notifications/${id}/read`, {});
    });
  };

  markAllAsRead = () => {
    return requestWithErrorHandling(async () => {
      return await apiService.put<any>("/notifications/mark-all-read", {});
    });
  };
}

export const notificationsService = NotificationsService.getInstance();
